var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ApiClient } from '../../api/apiClient';
import { useForm } from '../../context/FormContext';
import { SelectedVehicle } from './selectedVehicle';
import { trackVehicleOptionsAndPacks } from '../../utils/analytics';
export var VehicleOptionsAndPacks = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var selectedVehicle = _a.selectedVehicle, onNextStep = _a.onNextStep, onBack = _a.onBack, onRegoLookup = _a.onRegoLookup;
    // Get regoDetails from context
    var formState = useForm().state;
    var _w = useState([]), variantOptions = _w[0], setVariantOptions = _w[1];
    var _x = useState([]), variantPacks = _x[0], setVariantPacks = _x[1];
    var _y = useState([]), selectedVariantOptions = _y[0], setSelectedVariantOptions = _y[1];
    var _z = useState([]), selectedVariantPacks = _z[0], setSelectedVariantPacks = _z[1];
    var _0 = useState(false), isLoadingVariantOptions = _0[0], setIsLoadingVariantOptions = _0[1];
    var _1 = useState(false), isLoadingVariantPacks = _1[0], setIsLoadingVariantPacks = _1[1];
    var _2 = useState(false), isSubmitting = _2[0], setIsSubmitting = _2[1];
    var _3 = useState(null), error = _3[0], setError = _3[1];
    var _4 = useState(null), formError = _4[0], setFormError = _4[1];
    // Initialize selected options and packs from saved data
    useEffect(function () {
        var _a;
        var savedFormData = ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
        if (savedFormData.vehicle_options_and_packs) {
            setSelectedVariantOptions(savedFormData.vehicle_options_and_packs.split(',').map(function (opt) { return opt.trim(); }));
        }
        if (savedFormData.vehicle_variant_packs) {
            setSelectedVariantPacks(savedFormData.vehicle_variant_packs.split(',').map(function (pack) { return pack.trim(); }));
        }
    }, []);
    // Fetch variant options and packs when component mounts
    useEffect(function () {
        var fetchOptionsAndPacks = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, optionsData, sortedOptions, sortedPacks, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(selectedVehicle === null || selectedVehicle === void 0 ? void 0 : selectedVehicle.variantCode) || selectedVehicle.variantCode === '') {
                            setError('No variant code available for this vehicle');
                            return [2 /*return*/];
                        }
                        // Validate variant code format
                        if (!/^[a-zA-Z0-9-_]+$/.test(selectedVehicle.variantCode)) {
                            setError('Invalid variant code format');
                            return [2 /*return*/];
                        }
                        setIsLoadingVariantOptions(true);
                        setIsLoadingVariantPacks(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ApiClient.fetchVariantOptionsAndPacks(selectedVehicle.variantCode)];
                    case 2:
                        response = _a.sent();
                        if (response.success && response.data) {
                            optionsData = response.data;
                            sortedOptions = optionsData.AvailableOptions && optionsData.AvailableOptions.length > 0
                                ? __spreadArray([], optionsData.AvailableOptions, true).sort(function (a, b) { return a.Name.localeCompare(b.Name); })
                                : [];
                            sortedPacks = optionsData.AvailablePacks && optionsData.AvailablePacks.length > 0
                                ? __spreadArray([], optionsData.AvailablePacks, true).sort(function (a, b) { return a.Name.localeCompare(b.Name); })
                                : [];
                            setVariantOptions(sortedOptions);
                            setVariantPacks(sortedPacks);
                        }
                        else {
                            setError(response.error || 'Failed to fetch options and packs');
                        }
                        setIsLoadingVariantOptions(false);
                        setIsLoadingVariantPacks(false);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setError(err_1 instanceof Error ? err_1.message : 'An error occurred while fetching options and packs');
                        setIsLoadingVariantOptions(false);
                        setIsLoadingVariantPacks(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchOptionsAndPacks();
    }, [selectedVehicle]);
    var handleVariantOptionChange = function (optionId) {
        setSelectedVariantOptions(function (prev) {
            if (prev.includes(optionId)) {
                return prev.filter(function (id) { return id !== optionId; });
            }
            return __spreadArray(__spreadArray([], prev, true), [optionId], false);
        });
    };
    var handleVariantPackChange = function (packId) {
        setSelectedVariantPacks(function (prev) {
            if (prev.includes(packId)) {
                return prev.filter(function (id) { return id !== packId; });
            }
            return __spreadArray(__spreadArray([], prev, true), [packId], false);
        });
    };
    var handleNextClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedOptionsNames, selectedPacksNames, savedFormData, entryMethod, regoNumber, regoState, regoStateName, vehicleManufacturer, vehicleYear, vehicleModel, vehicleSeries, vehicleVariant, enhancedVehicle, apiData, result, scriptEl, err_2;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    setIsSubmitting(true);
                    setFormError(null);
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 7, 8, 9]);
                    selectedOptionsNames = selectedVariantOptions
                        .map(function (id) { var _a; return ((_a = variantOptions.find(function (o) { return o.Id === id; })) === null || _a === void 0 ? void 0 : _a.Id) || ''; })
                        .filter(Boolean);
                    selectedPacksNames = selectedVariantPacks
                        .map(function (id) { var _a; return ((_a = variantPacks.find(function (p) { return p.Id === id; })) === null || _a === void 0 ? void 0 : _a.Id) || ''; })
                        .filter(Boolean);
                    savedFormData = ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
                    entryMethod = formState.entryMethod || savedFormData.entry_method || 'rego';
                    regoNumber = ((_b = formState.regoDetails) === null || _b === void 0 ? void 0 : _b.rego) || savedFormData.vehicle_rego || '';
                    regoState = ((_c = formState.regoDetails) === null || _c === void 0 ? void 0 : _c.state) || savedFormData.vehicle_state || '';
                    regoStateName = ((_d = formState.regoDetails) === null || _d === void 0 ? void 0 : _d.stateName) || savedFormData.vehicle_state_name || '';
                    vehicleManufacturer = ((_e = formState.manualLookupDetails) === null || _e === void 0 ? void 0 : _e.manufacturer) || savedFormData.vehicle_manufacturer || '';
                    vehicleYear = ((_f = formState.manualLookupDetails) === null || _f === void 0 ? void 0 : _f.year) || savedFormData.vehicle_year || '';
                    vehicleModel = ((_g = formState.manualLookupDetails) === null || _g === void 0 ? void 0 : _g.model) || savedFormData.vehicle_model || '';
                    vehicleSeries = ((_h = formState.manualLookupDetails) === null || _h === void 0 ? void 0 : _h.series) || savedFormData.vehicle_series || '';
                    vehicleVariant = selectedVehicle.variantCode || savedFormData.vehicle_variant || '';
                    enhancedVehicle = __assign(__assign({}, selectedVehicle), { selectedOptions: selectedOptionsNames, selectedPacks: selectedPacksNames });
                    apiData = {
                        vehicle_entry_method: entryMethod,
                        vehicle_rego: regoNumber,
                        vehicle_state: regoState,
                        vehicle_state_name: regoStateName,
                        vehicle_manufacturer: vehicleManufacturer,
                        vehicle_model: vehicleModel,
                        vehicle_year: vehicleYear,
                        vehicle_series: vehicleSeries,
                        vehicle_variant: vehicleVariant,
                        selectedOptions: selectedOptionsNames.join(', '),
                        selectedPacks: selectedPacksNames.join(', '),
                        vehicleDetails: enhancedVehicle
                    };
                    return [4 /*yield*/, ApiClient.submitVehicleOptionsAndPacks(apiData)];
                case 2:
                    result = _j.sent();
                    if (!result.success) return [3 /*break*/, 5];
                    if (!result.js_update) return [3 /*break*/, 4];
                    scriptEl = document.createElement('div');
                    scriptEl.innerHTML = result.js_update;
                    document.body.appendChild(scriptEl);
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                case 3:
                    _j.sent();
                    document.body.removeChild(scriptEl);
                    _j.label = 4;
                case 4:
                    // Track vehicle options and packs selection (Step 1.5)
                    trackVehicleOptionsAndPacks();
                    // Pass the enhanced vehicle with array options to next step
                    onNextStep(enhancedVehicle, selectedOptionsNames.join(', '), selectedPacksNames.join(', '));
                    return [3 /*break*/, 6];
                case 5:
                    // Handle error from server
                    setFormError(result.error || 'Failed to save vehicle details. Please try again.');
                    _j.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    err_2 = _j.sent();
                    setFormError('Failed to process vehicle options and packs');
                    return [3 /*break*/, 9];
                case 8:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "vehicle-options-and-packs", children: [_jsx(SelectedVehicle, { vehicle: selectedVehicle, vehicleRego: formState.entryMethod === 'rego' ? ((_b = formState.regoDetails) === null || _b === void 0 ? void 0 : _b.rego) || '' : ((_c = formState.manualLookupDetails) === null || _c === void 0 ? void 0 : _c.rego) || '', onNotYourCar: onRegoLookup }), _jsx("h2", { className: "text-center", children: ((_f = (_e = (_d = window.tiofSettings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e.vehicleOptionsAndPacks) === null || _f === void 0 ? void 0 : _f.title) || 'Any Optional Extras?' }), _jsx("p", { className: 'text-center extra-pad-bottom', children: ((_j = (_h = (_g = window.tiofSettings) === null || _g === void 0 ? void 0 : _g.i18n) === null || _h === void 0 ? void 0 : _h.vehicleOptionsAndPacks) === null || _j === void 0 ? void 0 : _j.description) || 'Does your car come with any Options? If so, please select all that apply.' }), _jsxs("form", { onSubmit: function (e) {
                    e.preventDefault();
                    handleNextClick();
                }, children: [_jsxs("div", { className: "form-group full-width", children: [_jsx("label", { className: 'heading-label', children: ((_m = (_l = (_k = window.tiofSettings) === null || _k === void 0 ? void 0 : _k.i18n) === null || _l === void 0 ? void 0 : _l.vehicleOptionsAndPacks) === null || _m === void 0 ? void 0 : _m.optionsLabel) || 'Vehicle Options' }), isLoadingVariantOptions ? (_jsx("div", { className: "loading-text", children: "Loading options..." })) : (_jsxs("div", { className: "checkbox-list", children: [variantOptions.map(function (option) { return (_jsxs("div", { className: "checkbox-item", children: [_jsx("input", { type: "checkbox", id: "option-".concat(option.Id), checked: selectedVariantOptions.includes(option.Id), onChange: function () { return handleVariantOptionChange(option.Id); }, disabled: isSubmitting }), _jsx("label", { htmlFor: "option-".concat(option.Id), children: option.Name })] }, option.Id)); }), variantOptions.length === 0 && (_jsx("div", { className: "no-options", children: "No options available" }))] }))] }), isLoadingVariantPacks ? (_jsx("div", { className: "loading-text", children: "Loading packs..." })) : variantPacks.length > 0 && (_jsxs("div", { className: "form-group full-width", children: [_jsx("label", { className: 'heading-label', children: ((_q = (_p = (_o = window.tiofSettings) === null || _o === void 0 ? void 0 : _o.i18n) === null || _p === void 0 ? void 0 : _p.vehicleOptionsAndPacks) === null || _q === void 0 ? void 0 : _q.packsLabel) || 'Vehicle Packs' }), _jsx("div", { className: "checkbox-list", children: variantPacks.map(function (pack) { return (_jsxs("div", { className: "checkbox-item", children: [_jsx("input", { type: "checkbox", id: "pack-".concat(pack.Id), checked: selectedVariantPacks.includes(pack.Id), onChange: function () { return handleVariantPackChange(pack.Id); }, disabled: isSubmitting }), _jsx("label", { htmlFor: "pack-".concat(pack.Id), children: pack.Name })] }, pack.Id)); }) })] })), _jsx("div", { className: "clearfix" }), _jsx("div", { className: "form-group text-right half-width pad-top-25", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: onBack, disabled: isSubmitting, children: ((_t = (_s = (_r = window.tiofSettings) === null || _r === void 0 ? void 0 : _r.i18n) === null || _s === void 0 ? void 0 : _s.vehicleOptionsAndPacks) === null || _t === void 0 ? void 0 : _t.back) || 'Back' }) }), _jsx("div", { className: "form-group half-width pad-top-25", children: _jsx("button", { type: "submit", className: "button", disabled: isSubmitting, children: isSubmitting
                                ? 'Saving...'
                                : (((_v = (_u = window.tiofSettings) === null || _u === void 0 ? void 0 : _u.i18n) === null || _v === void 0 ? void 0 : _v.next) || 'Next') }) }), error && _jsx("div", { className: "error-message", children: error }), formError && _jsx("div", { className: "error-message", children: formError })] })] }));
};
